"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _getSession = _interopRequireDefault(require("./getSession"));

var _getSignature = _interopRequireDefault(require("./getSignature"));

var _getJWT = _interopRequireDefault(require("./getJWT"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _default(body) {
  var getHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var jwt = (0, _getJWT["default"])();
  var headers = getHeaders(body);

  if (jwt) {
    return _objectSpread({
      'X-ORION-JWT': jwt
    }, headers);
  }

  var session = (0, _getSession["default"])();
  if (!session) return _objectSpread({}, headers);
  var publicKey = session.publicKey,
      secretKey = session.secretKey;
  if (!publicKey || !secretKey) return _objectSpread({}, headers);
  var nonce = new Date().getTime();
  var signature = (0, _getSignature["default"])(nonce + body, session);
  return _objectSpread({
    'X-ORION-NONCE': nonce,
    'X-ORION-PUBLICKEY': publicKey,
    'X-ORION-SIGNATURE': signature
  }, headers);
}